import type { AlbumDto } from '../../generated/tellus';

export interface DocumentItem {
  name: string;
  contentType: string;
  path: string;
  modifiedBy: string;
  modifiedAt: Date;
  children?: DocumentItem[] | null;
  webUrl?: string;
  appUrl?: string;
}

export interface AlbumItem extends AlbumDto {
  kind: 'album';
}

export type LibraryItem = DocumentItem | AlbumItem;

export const isAlbumItem = (item: LibraryItem | undefined): item is AlbumItem =>
  item != null && 'kind' in item && item.kind === 'album';

export interface MixedDocumentItem extends DocumentItem {
  documentId: string;
}

export interface CreateDocument {
  name?: string;
  file?: File;
  path?: string;
}
